import type { VConsoleDefaultPlugin, VConsoleSerializableConfig } from "./vconsoleDefaults";
import { VCONSOLE_ALL_PLUGINS, VCONSOLE_DEFAULT_MAX_LOG } from "./vconsoleDefaults";

/**
 * 与 URL / localStorage 合并后的选项（仅浏览器环境）。
 * 逻辑需与 build/vite/vconsoleInlineHtml.ts 内联脚本保持一致。
 */
export function parseVConsoleRuntimeOptions(): Pick<
  VConsoleSerializableConfig,
  "defaultPlugins" | "maxLogNumber"
> {
  const params = new URLSearchParams(window.location.search);
  const maxFromQuery = params.get("vconsole_max_log");
  const maxFromStorage = localStorage.getItem("vconsole_max_log");
  const pluginFromQuery = params.get("vconsole_plugins");
  const pluginFromStorage = localStorage.getItem("vconsole_plugins");

  const parsedMax = Number(maxFromQuery ?? maxFromStorage ?? String(VCONSOLE_DEFAULT_MAX_LOG));
  const maxLogNumber = Number.isFinite(parsedMax)
    ? Math.min(Math.max(parsedMax, 500), 20000)
    : VCONSOLE_DEFAULT_MAX_LOG;

  const raw = (pluginFromQuery ?? pluginFromStorage ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const defaultPlugins: VConsoleDefaultPlugin[] = raw.length
    ? (raw as VConsoleDefaultPlugin[])
    : [...VCONSOLE_ALL_PLUGINS];

  return {
    defaultPlugins,
    maxLogNumber,
  };
}
